import React from "react";
import Tab from "components/tabs/tabs";
import {useTranslation} from "react-i18next";

const InvoicesTabs = () => {
    const {t} = useTranslation('invoices')
  return (
    <div className="tabs">
      <div className="nav">
        <Tab url="../unpaid" title={t('unpaid')} end />
        <Tab url="../paid" title={t('paid')} end />
        <Tab url="../refunded" title={t('refund')} end />
        <Tab url="../canceled" title={t('canceled')} end />
      </div>
    </div>
  );
};

export default InvoicesTabs;
